/**
 * 描述：左侧导航点击效果指令
 * 日期：2017/10/25
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('editingCenterLeftDirModule', [])
    . directive('editingCenterLeftDir', [
        '$timeout', 
        '$q',
        '$state',
        'permissionService',
        'localStorageService',
        '$sessionStorage',
        'publicToolService',
        function(
            $timeout,
            $q, $state,
            permissionService,
            localStorageService,
            $sessionStorage,
            publicToolService
        ) {
            return {
                restrict: 'C',
                replace: false,
                scope: false,
                transclude: false,
                link: function(scope, $elem) {

                    init();

                    /**
                     * [init description] 初始化
                     * @return {[type]} [description]
                     */
                    function init() {
                        watcherInit().then(() => {
                            hideAllTargetPannel();
                            level1BindClick();
                            level2BindClick();
                            newspaperClick();
                            initSelectLevel1();
                            isAdministrator();
                        });
                        publicToolService.getModeconfiguration('quickSign').then((config) => {
                            scope.status.quickSignShield = config.shield;
                        });
                    }

                    /**
                     * [watcherInit description] 监控，是否开始初始化
                     * @return {[type]} [description]
                     */
                    function watcherInit() {
                        let deffer = $q.defer(),
                            timer;
                        let watcher = scope.$watch('status.doLeftDir', (newV) => {
                            if (newV) {
                                watcher();
                                timer = $timeout(() => {
                                    deffer.resolve();
                                }, 500);
                            }
                        });
                        scope.$on('$destroy', () => {
                            $timeout.cancel(timer);
                        });
                        return deffer.promise;
                    }

                    /**
                     * [showTargetPannel description] 一级菜单绑定事件
                     * @return {[type]} [description]
                     */
                    function level1BindClick() {
                        var btns = $elem.find('*[ld-switchBtn]');
                        $elem.delegate('*[ld-switchBtn]', 'click', function(event) {
                            var isOn = ($(this).hasClass('on'));
                            var isHasLevel2 = !!$(this).next().length;
                            if (isHasLevel2) {level1ClickHasChildren($(this), isOn);} else {level1ClickNoChildren(btns, $(this));}
                            if ($(this).attr('ld-switchbtn') === '3') { // 为报纸渠道做的特殊处理
                                var openMenu = $elem.find('.sidebar_content_pan');
                                openMenu.removeClass('menu_start');
                            }
                        });
                    }

                    /**
                     * [level1ClickHasChildren description] 有level2菜单的level1按钮点击事件
                     * @param {$dom} [$dom] [description] 按钮元素
                     * @param {string} [isOpen] [description] 是否已经被选中
                     * @return {[type]} [description]
                     */
                    function level1ClickHasChildren($dom) {
                        var isOpen = $dom.attr('class').indexOf('open') >= 0;
                        if (isOpen) {
                            $dom.removeClass('open');
                            scope.$broadcast('newspaperDropDown', true);
                        } else {
                            $dom.addClass('open');
                            if (scope.isNotFirst && $dom.attr('ld-switchbtn') !== scope.mediaState) {
                                scope.mediaState = $dom.attr('ld-switchbtn'); // 记录下当前单击的是哪一个渠道，避免点击同一个渠道时触发
                                var children = $dom.next().children();
                                if (getState(children)) {
                                    return;
                                }
                                if ($dom.attr('ld-switchbtn') === '3') { // 纸媒渠道特殊对待，若是一级审核默认进入上版稿，二级审核默认进入今日稿,其它渠道默认进入第一个
                                    if (children[1].innerText === '上版稿') {
                                        children[1].click();
                                    } else {
                                        children[2].click();
                                    }
                                } else {
                                    children[0].click();
                                }
                            } else {
                                scope.isNotFirst = true;
                            }
                        }
                    }

                    /**
                     * [getState description]
                     * @param  {[type]}  children   [$dom description]
                     * @return  {[type]}   [return description]
                     */
                    function getState(children) {
                        var userId = $sessionStorage.get('curUserInfo').ID;
                        var state = localStorageService.get('global.state');
                        var name = scope.status.mediaType[scope.mediaState];
                        if (userId && state && state[userId] && state[userId][name]) {
                            if (state[userId][name].url === $state.current.name) {
                                return false;
                            }
                            $state.transitionTo(state[userId][name].url, state[userId][name].query, {
                                reload: false
                            });
                            if (angular.isUndefined(state[userId][name].index)) {
                                return false;
                            }
                            setTimeout(function() {
                                children[state[userId][name].index].click();
                            });
                            return true;
                        }
                    }

                    /**
                     * [level1ClickNoChildren description]没有level2菜单的level1按钮点击事件
                     * @param   {[type]}  btns  [btns description] 
                     * @param   {[type]}  $dom  [$dom description] 按钮元素
                     * @return  {[type]}        [return description]
                     */
                    function level1ClickNoChildren(btns, $dom) {
                        btns.removeClass('on');
                        $dom.addClass('on');
                        $elem.find('*[ld-switchBtn]').next().find('li').find('a').removeClass('active');
                        var isPannelShow = ($elem.find('.sidebar_content_pan').attr('class').indexOf('menu_start') >= 0);
                        var selfIndex = Number($dom.attr('ld-switchBtn'));
                        var showPannelIndex;
                        $elem.find('*[ld-targetPanel]').each(function(index) {
                            if ($(this).css('display') !== 'none') {
                                showPannelIndex = (index + 1);
                            }
                        });
                        var isSelf = selfIndex === showPannelIndex;
                        if (isPannelShow && isSelf) {
                            justClose();
                        } else {
                            var index = $dom.attr('ld-switchBtn');
                            showPannel(index);
                        }
                    }

                /**
                 * [showPannel description]展示面板
                 *
                 * @param   {[type]}  index  [index description]
                 *
                 * @return  {[type]}         [return description]
                 */
                function showPannel(index) {
                    justOpen();
                    $elem.find('*[ld-targetPanel]').hide();
                    $elem.find("*[ld-targetPanel='" + index + "']").show();
                }

                /**
                 * [level2BindClick description] 二级菜单按钮绑定点击事件
                 * @return {[type]} [description]
                 */
                function level2BindClick() {
                    $elem.delegate('*[ld-initSelectedLevel2]', 'click', function(event) {
                        var $lastTimeBtn = $elem.find('*[ld-initSelectedLevel2] a.active');
                        $elem.find('*[ld-initSelectedLevel2] a').removeClass('active');
                        $elem.find('*[ld-initSelectedLevel2_paper] a').removeClass('active');
                        $(this).find('a').addClass('active');
                        var index = $(this).parent().prev().attr('ld-switchBtn');
                        scope.mediaState = index;
                        $elem.find('*[ld-switchBtn]').removeClass('on');
                        var pannelIsShow = ($elem.find("*[ld-targetPanel='" + index + "']").css('display') !== 'none');
                        hideAllTargetPannel();
                        showPannel(index);
                    });
                }

                    /**
                     * [level2BindClick description] 二级菜单按钮绑定点击事件
                     * @return {[type]} [description]
                     */
                    function level2BindClick() {
                        $elem.delegate('*[ld-initSelectedLevel2]', 'click', function(event) {
                            $elem.find('*[ld-initSelectedLevel2] a').removeClass('active');
                            $elem.find('*[ld-initSelectedLevel2_paper] a').removeClass('active');
                            $(this).find('a').addClass('active');
                            var index = $(this).parent().prev().attr('ld-switchBtn');
                            scope.mediaState = index;
                            $elem.find('*[ld-switchBtn]').removeClass('on');
                            hideAllTargetPannel();
                            showPannel(index);
                        });
                    }

                    /**
                     * [newspaperClick description]
                     * @return  {[type]}  [return description]
                     */
                    function newspaperClick() {
                        $elem.delegate('*[ld-initSelectedLevel2_paper]', 'click', function(event) {
                            if ($(this).attr('ld-initselectedlevel2_paper') !== 'noActive') {
                                $elem.find('*[ld-initSelectedLevel2] a').removeClass('active');
                                $elem.find('*[ld-initSelectedLevel2_paper] a').removeClass('active');
                                $(this).find('a').addClass('active');
                                $elem.find('*[ld-switchBtn]').removeClass('on');
                                hideAllTargetPannel();
                                justClose();
                            }
                        });
                    }

                    /**
                     * [initSelectLevel1 description] 初始化选中一级菜单
                     * @return {[type]} [description]
                     */
                    var loadIndex = 0;

                    /**
                     * [initSelectLevel1 description]
                     * @return  {[type]}  [return description]
                     */
                    function initSelectLevel1() {
                        var timer = $timeout(function() {
                            if (loadIndex === 2) {
                                return;
                            }
                            if ($elem.find("*[ld-initSelectedLevel1='true']").length === 0) {
                                initSelectLevel1();
                                loadIndex++;
                                return;
                            }
                            $elem.find("*[ld-initSelectedLevel1='true']")[0].click();
                            initSelectLevel2();
                            loadIndex = 0;
                        });
                        scope.$on('$destroy', function() { // 当页面切走时，也就是当前节点被销毁时，停止一切定时任务
                            $timeout.cancel(timer);
                        });
                    }
                    var loadIndex2 = 0;

                    /**
                     * [initSelectLevel2 description]
                     * @return  {[type]}  [return description]
                     */
                    function initSelectLevel2() {
                        var timer = $timeout(function() {
                            $elem.find("*[ld-initSelectedLevel2_paper='true'] a").addClass('active');
                            if (loadIndex2 === 2) {
                                if ($elem.find("*[ld-initSelectedLevel1='true']").next().find('*[ld-initSelectedLevel2]').length === 0) {return;}
                                $elem.find("*[ld-initSelectedLevel1='true']").next().find('*[ld-initSelectedLevel2]')[0].click();
                                return;
                            }
                            if ($elem.find("*[ld-initSelectedLevel1='true']").next().find("*[ld-initSelectedLevel2='true']").length === 0) {
                                initSelectLevel2();
                                loadIndex2++;
                                return;
                            }
                            $elem.find("*[ld-initSelectedLevel1='true']").next().find("*[ld-initSelectedLevel2='true']").click();
                            loadIndex2 = 0;
                        });
                        scope.$on('$destroy', function() { // 当页面切走时，也就是当前节点被销毁时，停止一切定时任务
                            $timeout.cancel(timer);
                        });
                    }

                    /**
                     * [hideAllTargetPannel description] 初始化隐藏所有目标面板
                     * @return {[type]} [description]
                     */
                    function hideAllTargetPannel() {
                        $elem.find('*[ld-targetPanel]').each(function() {
                            $(this).hide();
                        });
                    }

                    /**
                     * [justOpen description] 仅仅打开菜单面板
                     * @return {[type]} [description]
                     */
                    function justOpen() {
                        $elem.find('.icon-menu_unfold_ic_').removeClass('icon-menu_unfold_ic_').addClass('icon-menu_fold_ic_');
                        var openMenu = $elem.find('.sidebar_content_pan');
                        openMenu.addClass('menu_start');
                    }

                    /**
                     * [justClose description] 仅仅关闭
                     * @return {[type]} [description]
                     */
                    function justClose() {
                        $elem.find('.icon-menu_fold_ic_').removeClass('icon-menu_fold_ic_').addClass('icon-menu_unfold_ic_');
                        var openMenu = $elem.find('.sidebar_content_pan');
                        openMenu.removeClass('menu_start');
                    }

                    /**
                     * [isAdministrator description] 查询当前用户是不是系统管理员
                     * @return {Boolean} [description]
                     */
                    function isAdministrator() {
                        permissionService.isAdministrator().then(function(data) {
                            scope.isAdministrator = data;
                        });
                    }
                }
            };
        }]);
